export default `float g=1.;
    float e=0.;
    vec3 q=vec3(0.0);
    p.z-=1.;
    q=p;
    float s=2.;
    for(int j=0;j++<8;)
      p-=clamp(p,-.9,.9)*2.,
      p=p*(e=3./min(dot(p,p),1.))+q,
      s*=e;
    return length(p)/s;
  }`